angular.module('picmonicng').factory('PlaylistService', [
  '$rootScope',
  '$q',
  '$filter',
  '$modal',
  'Tracks',
  'Playlists',
  'User',
  'UserService',
  'toaster',
  function ($rootScope, $q, $filter, $modal, Tracks, Playlists, User, UserService, toaster) {
    var PlaylistService = {
      //Array of all user playlists
      playlists: [],

      //Loading status of the playlist
      loading: false,

      pendingRequests: 0,

      initialPromise: null,

      init: function () {
        var self = this;
        var promise = self.getPlaylists();

        // Listen for data change event
        var onChange = function (event, data) {
          if (data.promise) {
            self.pendingRequests++;
            data.promise.then(function () {
              self.pendingRequests--;
              if (self.pendingRequests == 0) {
                self.getPlaylists();
              }
            });
          } else {
            if (self.pendingRequests == 0) {
              self.getPlaylists();
            }
          }
        };

        $rootScope.$on('playlistDataChanged', onChange);
        $rootScope.$on('playlistCardDataChanged', onChange);
        $rootScope.$on('cardDataChanged', onChange);

        self.initialPromise = promise;

        return promise;
      },

      getTrack: function () {
        var self = this;
        self.loading = true;

        if (UserService.user.current_track_id) {
          Tracks.get({ track_id: UserService.user.current_track_id }, function (track) {
            self.current = track;
            self.current.sort_method = 'custom';
            self.loading = false;

            Tracks.get({ track_id: track.track_id, resource: 'picmonics' }, function (cards) {
              self.cards = cards.cards;
              self.cardsLoading = false;
            });
          });
        } else {
          self.loading = false;
          self.cardsLoading = false;
        }
      },

      getPlaylist: function (playlist_id) {
        return Playlists.find({ playlist_id: playlist_id });
      },

      //Get all user playlists
      getPlaylists: function () {
        var self = this;

        //Get user playlists
        self.loading = true;
        var promise = Playlists.query();

        promise.$promise.then(function (playlists) {
          self.playlists = playlists;
          self.loading = false;
        });

        return promise;
      },

      getCurrentPlaylist: function () {
        var self = this;
        return self.playlists[$filter('arrayPos')(self.playlists, UserService.user.current_playlist, 'playlist_id')];
      },

      //Create a new playlist
      create: function () {
        var self = this;

        return $q(function (resolve, reject) {
          $modal.open({
            templateUrl: '/templates/modals/playlist-create.html',
            backdrop: true,
            controller: [
              '$scope',
              '$modalInstance',
              'User',
              'PlaylistService',
              function ($scope, $modalInstance, User, PlaylistService) {
                $scope.playlist = {};

                $scope.submit = function () {
                  if (!$scope.loading) {
                    $scope.loading = true;

                    if (!$scope.playlist.name || !$scope.playlist.name.trim().length) {
                      $scope.error = 'Your playlist must contain at least one character to continue!';
                      $scope.loading = false;
                      return;
                    }

                    Playlists.save($scope.playlist)
                      .$promise.then(
                        function (response) {
                          self.playlists.push(response);

                          resolve(response);
                          $modalInstance.close();
                          UserService.user.current_playlist = response.playlist_id;
                          UserService.user.playlist_created = 1;
                          UserService.user.$update();
                        },
                        function (response) {
                          $scope.error =
                            response && response.data && response.data.error ? response.data.error : response;
                        }
                      )
                      .finally(function () {
                        $rootScope.$broadcast('playlistDataChanged', {
                          action: 'create',
                        });
                        $scope.loading = false;
                      });
                  }
                };

                $scope.close = function () {
                  reject();
                  $modalInstance.close();
                };
              },
            ],
          });
        });
      },

      //Get the cards for a playlist
      getCards: function (playlist) {
        var self = this;
        var playlistCard = Playlists.query({
          resource: 'picmonics',
          playlist_id: playlist.playlist_id,
        });

        playlistCard.$promise.then(function (cards) {
          cards.map(function (obj) {
            obj.random_order = Math.random();
            return obj;
          });
        });

        return playlistCard;
      },

      // Add a card to the current plyalist
      addCard: function (card_id, playlist, success) {
        var self = this;
        self.loading = true;

        var data = {
          card_id: card_id,
          playlist_id: playlist.playlist_id,
          resource: 'picmonics',
        };

        var promise = Playlists.save(data).$promise;
        promise
          .then(function () {
            if (typeof success == 'function') {
              success();
            }

            send_ga('event', 'Library', 'Picmonic Added To Playlist');

            var matchingPlaylist =
              self.playlists[$filter('arrayPos')(self.playlists, playlist.playlist_id, 'playlist_id')];

            if (typeof matchingPlaylist.picmonics != 'object') {
              matchingPlaylist.picmonics = [];
            }

            if (matchingPlaylist.picmonics.indexOf(card_id) == -1) {
              matchingPlaylist.picmonics.push(card_id);
            }

            UserService.user.current_playlist = playlist.playlist_id;
            UserService.user.$update();

            $rootScope.$broadcast('playlistCardDataChanged', {
              action: 'addCard',
              card_id: card_id,
              playlist_id: playlist.playlist_id,
              promise: promise,
            });

            toaster.success('', 'Picmonic added to "' + playlist.name + '"!', {
              positionClass: 'toast-bottom-right',
            });
          })
          .finally(function () {
            self.loading = false;
          });

        return promise;
      },

      addTrack: function (track_id, playlist, success) {
        var self = this;
        self.loading = true;

        var data = {
          track_id: track_id,
          playlist_id: playlist.playlist_id,
          resource: 'picmonics',
        };

        var promise = Playlists.save(data);

        promise.$promise.then(
          function () {
            if (typeof success == 'function') {
              success();
            }

            send_ga('event', 'Library', 'Track Added To Playlist');

            self.loading = false;

            UserService.user.current_playlist = playlist.playlist_id;
            UserService.user.$update();

            $rootScope.$broadcast('playlistCardDataChanged', {
              action: 'addTrack',
              track_id: track_id,
              playlist_id: playlist.playlist_id,
              promise: promise.$promise,
            });

            toaster.success('', 'Path added to "' + playlist.name + '"!', {
              positionClass: 'toast-bottom-right',
            });
          },
          function () {
            self.loading = false;
          }
        );

        return promise.$promsie;
      },

      addPathway: function (pathway_id, playlist, success) {
        var self = this;
        self.loading = true;

        var data = {
          pathway_id: pathway_id,
          playlist_id: playlist.playlist_id,
          resource: 'picmonics',
        };

        var promise = Playlists.save(data);
        promise.$promise.then(
          function () {
            if (typeof success == 'function') {
              success();
            }

            send_ga('event', 'Library', 'Track Added To Playlist');

            self.loading = false;

            UserService.user.current_playlist = playlist.playlist_id;
            UserService.user.$update();

            $rootScope.$broadcast('playlistCardDataChanged', {
              action: 'addPathway',
              pathway_id: pathway_id,
              playlist_id: playlist.playlist_id,
              promise: promise.$promise,
            });

            toaster.success('', 'Pathway added to "' + playlist.name + '"!', {
              positionClass: 'toast-bottom-right',
            });
          },
          function () {
            self.loading = false;
          }
        );

        return promise.$promise;
      },

      //Remove a card from the current playlist
      removeCard: function (card_id, playlist, success) {
        var self = this;
        var playlist_id = playlist.playlist_id ? playlist.playlist_id : playlist.id;
        playlist = self.playlists[$filter('arrayPos')(self.playlists, playlist_id, 'playlist_id')];

        if (!playlist) {
          return;
        }

        self.loading = true;

        var data = {
          resource_id: card_id,
          playlist_id: playlist_id,
          resource: 'picmonics',
        };

        var deferred = Playlists.delete(data, function () {
          toaster.success('', 'Picmonic removed from "' + playlist.name + '"!');
          if (typeof success == 'function') {
            success();
          }
        });

        $rootScope.$broadcast('playlistCardDataChanged', {
          action: 'removeCard',
          card_id: card_id,
          playlist_id: playlist_id,
          promise: deferred.$promise,
        });

        return deferred.$promise;
      },

      moveCard: function (card, position, playlist, success) {
        var self = this;
        var playlist_id = playlist.playlist_id ? playlist.playlist_id : playlist.id;
        playlist = self.playlists[$filter('arrayPos')(self.playlists, playlist_id, 'playlist_id')];

        if (!playlist) {
          return;
        }

        self.loading = true;

        var data = card;
        var positionMessage = position > 0 ? 'bottom' : 'top';
        data.playlist_id = playlist_id;
        data.resource = 'picmonics';
        data.sort_order = position;

        var deferred = Playlists.update(data, function () {
          toaster.success('', 'Picmonic moved to ' + positionMessage + ' in "' + playlist.name + '"!');
          if (typeof success === 'function') {
            success();
          }
        });

        $rootScope.$broadcast('playlistCardDataChanged', {
          action: 'moveCard',
          card_id: card.card_id,
          playlist_id: playlist_id,
          promise: deferred.$promise,
        });

        return deferred.$promise;
      },

      duplicate: function (playlist) {
        var self = this;

        return $q(function (resolve, reject) {
          $modal.open({
            templateUrl: '/templates/modals/playlist-create.html',
            backdrop: true,
            controller: [
              '$scope',
              '$modalInstance',
              'Playlists',
              function ($scope, $modalInstance, Playlists) {
                $scope.playlist = angular.copy(playlist);
                $scope.playlist.name = 'Copy of ' + $scope.playlist.name;

                $scope.submit = function () {
                  if (!$scope.playlist.name.trim().length) {
                    $scope.error = 'Your playlist must contain at least one character to continue!';
                    return;
                  }

                  $scope.loading = true;
                  $scope.playlist.resource = 'duplicate';

                  Playlists.savev3($scope.playlist)
                    .$promise.then(
                      function (response) {
                        self.playlists.push(response);
                        resolve(response);
                        $modalInstance.close();
                        $rootScope.$broadcast('playlistDataChanged', {
                          action: 'duplicate',
                          playlist_id: $scope.playlist.playlist_id,
                        });
                      },
                      function (response) {
                        $scope.error =
                          response && response.data && response.data.error ? response.data.error : response;
                      }
                    )
                    .finally(function () {
                      $scope.loading = false;
                    });
                };

                $scope.close = function () {
                  reject();
                  $modalInstance.close();
                };
              },
            ],
          });
        });
      },

      rename: function (playlist) {
        var self = this;

        return $q(function (resolve, reject) {
          $modal.open({
            templateUrl: '/templates/modals/playlist-rename.html',
            backdrop: true,
            controller: [
              '$scope',
              '$modalInstance',
              'Playlists',
              function ($scope, $modalInstance, Playlists) {
                $scope.playlist = angular.copy(playlist);

                $scope.submit = function () {
                  $scope.error = '';

                  if (!$scope.playlist.name.trim().length) {
                    $scope.error = 'Your playlist must contain at least one character to continue!';
                    return;
                  }

                  $scope.loading = true;
                  Playlists.update($scope.playlist)
                    .$promise.then(function (response) {
                      self.playlists[$filter('arrayPos')(self.playlists, response.playlist_id, 'playlist_id')].name =
                        response.name;
                      resolve(response);
                      $modalInstance.close();
                      $rootScope.$broadcast('playlistDataChanged', {
                        action: 'rename',
                        playlist_id: playlist.playlist_id,
                        name: $scope.playlist.name,
                      });
                    })
                    .finally(function () {
                      $scope.loading = false;
                    });
                };

                $scope.close = function () {
                  reject();
                  $modalInstance.close();
                };
              },
            ],
          });
        });
      },

      clear: function (playlist) {
        return $q(function (resolve, reject) {
          $modal.open({
            templateUrl: '/templates/modals/playlist-clear.html',
            backdrop: true,
            controller: [
              '$scope',
              '$modalInstance',
              'Playlists',
              function ($scope, $modalInstance, Playlists) {
                $scope.playlist = angular.copy(playlist);

                $scope.submit = function () {
                  $scope.loading = true;
                  Playlists.delete({
                    playlist_id: $scope.playlist.playlist_id,
                    resource: 'picmonics',
                  })
                    .$promise.then(
                      function () {
                        send_ga('event', 'Playlist', 'Playlist Cleared');
                        $modalInstance.close();
                        resolve();
                      },
                      function (error) {
                        $scope.error = error;
                      }
                    )
                    .finally(function () {
                      $scope.loading = false;
                      $rootScope.$broadcast('playlistDataChanged', {
                        action: 'clear',
                        playlist_id: $scope.playlist.playlist_id,
                      });
                    });
                };

                $scope.close = function () {
                  reject();
                  $modalInstance.close();
                };
              },
            ],
          });
        });
      },

      delete: function (playlist) {
        var self = this;

        return $q(function (resolve, reject) {
          $modal.open({
            templateUrl: '/templates/modals/playlist-delete.html',
            backdrop: true,
            controller: [
              '$scope',
              '$filter',
              '$modalInstance',
              'Playlists',
              function ($scope, $filter, $modalInstance, Playlists) {
                $scope.playlist = angular.copy(playlist);

                $scope.submit = function () {
                  $scope.loading = true;

                  Playlists.delete({ playlist_id: $scope.playlist.playlist_id })
                    .$promise.then(function () {
                      self.playlists.splice(
                        self.playlists[$filter('arrayPos')(self.playlists, $scope.playlist.playlist_id, 'playlist_id')],
                        1
                      );
                      send_ga('event', 'Playlist', 'Playlist Deleted');
                      resolve();
                      $modalInstance.close();
                    })
                    .finally(function () {
                      $scope.loading = false;
                      $rootScope.$broadcast('playlistDataChanged', {
                        action: 'delete',
                        playlist_id: $scope.playlist.playlist_id,
                      });
                    });
                };

                $scope.close = function () {
                  reject();
                  $modalInstance.close();
                };
              },
            ],
          });
        });
      },
    };

    return PlaylistService;
  },
]);
